{
  "common": {
    "loading": "Chargement...",
    "cancel": "Annuler",
    "close": "Fermer",
    "update": "Mettre à jour",
    "create": "Créer",
    "confirm": "Confirmer",
    "processing": "Traitement...",
    "yes": "Oui",
    "no": "Non",
    "unknown": "Inconnu",
    "actionFailed": "Échec de l'opération"
  },
  "tierLabels": {
    "starter": "Starter",
    "silver": "Silver",
    "gold": "Gold",
    "platinum": "Platinum"
  },
  "statusLabels": {
    "active": "Actif",
    "paused": "En pause",
    "banned": "Banni"
  },
  "kycLabels": {
    "pending": "Non soumis",
    "submitted": "En attente",
    "verified": "Vérifié",
    "rejected": "Rejeté"
  },
  "payoutStatusLabels": {
    "requested": "En attente",
    "approved": "Approuvé",
    "paid": "Payé",
    "rejected": "Rejeté"
  },
  "reasonLabels": {
    "ip_reuse": "Réutilisation d'IP",
    "velocity": "Vélocité anormale",
    "ua_anomaly": "User-Agent inhabituel",
    "manual": "Signalement manuel"
  },
  "commissionStatusLabels": {
    "pending": "En attente",
    "locked": "Verrouillé",
    "paid": "Payé",
    "refunded": "Remboursé"
  },
  "kycDocKinds": {
    "id_front": "Pièce d'identité (recto)",
    "id_back": "Pièce d'identité (verso)",
    "selfie": "Selfie",
    "address_proof": "Justificatif de domicile"
  },
  "hub": {
    "heading": "Gestion des affiliés",
    "subtitle": "Liste des affiliés, file de paiements, signalements de fraude et ShortLinks de la plateforme.",
    "tabsAria": "Onglets du hub affiliés",
    "panelAria": "Panneau {{tab}}",
    "tabs": {
      "list": "Liste des affiliés",
      "payouts": "File de paiements",
      "abuse": "Signalements de fraude",
      "shortlinks": "ShortLinks"
    }
  },
  "list": {
    "heading": "Liste des affiliés",
    "subtitle": "Liste des affiliés — filtrer par statut, palier, KYC.",
    "searchPlaceholder": "Rechercher par handle ou e-mail...",
    "filters": {
      "allTiers": "Tous les paliers",
      "tierOption": "Palier : {{label}}",
      "allStatuses": "Tous les statuts",
      "allKyc": "Tous les KYC",
      "kycOption": "KYC : {{label}}"
    },
    "columns": {
      "handle": "Handle",
      "tier": "Palier",
      "status": "Statut",
      "kyc": "KYC",
      "commissionMtd": "Commission du mois",
      "clicks": "Clics",
      "conversions": "Conversions",
      "lastActive": "Dernière activité"
    },
    "empty": "Aucun affilié ne correspond aux filtres."
  },
  "detail": {
    "loadError": "Impossible de charger les informations de l'affilié.",
    "tierBadge": "Palier : {{label}}",
    "kycBadge": "KYC : {{label}}",
    "tabs": {
      "profile": "Profil",
      "kyc": "KYC",
      "commissions": "Commissions",
      "clicks": "Clics",
      "payouts": "Historique des paiements"
    },
    "actions": {
      "suspend": "Suspendre",
      "changeTier": "Changer de palier",
      "forcePayout": "Paiement manuel",
      "whitelist": "Liste blanche IP"
    },
    "success": {
      "suspend": "Affilié suspendu.",
      "changeTier": "Palier modifié.",
      "forcePayout": "Demande de paiement créée.",
      "whitelist": "Liste d'IP mise à jour."
    },
    "errors": {
      "suspend": "Échec de la suspension.",
      "changeTier": "Échec du changement de palier.",
      "forcePayout": "Échec de la création du paiement.",
      "whitelist": "Échec de la mise à jour de l'IP."
    },
    "suspendForm": {
      "title": "Suspendre l'affilié",
      "reasonPlaceholder": "Motif de la suspension..."
    },
    "tierForm": {
      "title": "Changer de palier",
      "reasonPlaceholder": "Motif du changement de palier..."
    },
    "forcePayoutForm": {
      "title": "Paiement manuel",
      "amountLabel": "Montant (USD)",
      "reasonPlaceholder": "Motif..."
    },
    "whitelistForm": {
      "title": "Liste blanche IP",
      "empty": "Aucune IP en liste blanche.",
      "add": "Ajouter",
      "remove": "Supprimer"
    },
    "profile": {
      "email": "E-mail",
      "fullName": "Nom complet",
      "createdAt": "Créé le",
      "lastActive": "Dernière activité",
      "whitelistedIps": "IP en liste blanche"
    },
    "kyc": {
      "empty": "L'affilié n'a pas soumis de documents KYC.",
      "viewDoc": "Voir le document",
      "uploadedAt": "Téléversé : {{date}}"
    },
    "commissions": {
      "empty": "Aucune commission pour le moment.",
      "columns": {
        "order": "Commande",
        "amount": "Montant",
        "status": "Statut",
        "earned": "Gagné le",
        "locked": "Verrouillé le",
        "paid": "Payé le"
      }
    },
    "clicks": {
      "empty": "Aucun clic pour le moment.",
      "columns": {
        "slug": "Slug",
        "ip": "IP",
        "bot": "Bot ?",
        "when": "Quand",
        "converted": "Commande convertie"
      }
    },
    "payoutsHistory": {
      "empty": "Aucun historique de paiement pour le moment.",
      "columns": {
        "id": "ID",
        "amount": "Montant",
        "status": "Statut",
        "requested": "Demandé",
        "approved": "Approuvé",
        "paid": "Payé"
      }
    }
  },
  "payouts": {
    "heading": "File de paiements",
    "subtitle": "Approuver / rejeter / marquer payées les demandes de retrait des affiliés.",
    "filters": {
      "allStatuses": "Tous les statuts",
      "affiliateIdPlaceholder": "ID affilié...",
      "minAmount": "Minimum $"
    },
    "bulkMarkPaid": "Marquer payées en lot ({{count}})",
    "columns": {
      "affiliate": "Affilié",
      "amount": "Montant",
      "status": "Statut",
      "requestedAt": "Demandé le",
      "banking": "Banque",
      "actions": "Actions"
    },
    "empty": "Aucun paiement ne correspond aux filtres.",
    "rowActions": {
      "approve": "Approuver",
      "reject": "Rejeter",
      "markPaid": "Marquer payé"
    },
    "errors": {
      "approve": "Échec de l'approbation du paiement.",
      "markPaid": "Échec du marquage.",
      "reject": "Échec du rejet du paiement."
    },
    "toast": {
      "approveSuccess": "Opération réussie.",
      "markPaidSuccess": "Marqué comme payé.",
      "rejectSuccess": "Paiement rejeté.",
      "bulkSuccess": "{{count}} paiements payés.",
      "bulkPartial": "{{ok}} terminés, {{failed}} échoués."
    },
    "approveDrawer": {
      "title": "Approuver le paiement",
      "commentLabel": "Commentaire (facultatif)"
    },
    "rejectDrawer": {
      "title": "Rejeter le paiement",
      "reasonLabel": "Motif du rejet"
    },
    "markPaidDrawer": {
      "title": "Marquer comme payé",
      "bulkTitle": "Marquer payées en lot ({{count}})",
      "bulkNote": "S'applique à {{count}} paiements sélectionnés.",
      "bankRefLabel": "Référence bancaire",
      "paidAtLabel": "Date du paiement",
      "proofLabel": "URL du justificatif (facultatif)",
      "grossLabel": "Brut (USD)",
      "withholdLabel": "Retenue (USD)"
    }
  },
  "abuse": {
    "heading": "Signalement de fraude",
    "subtitle": "Signalements d'abus d'affiliés (fraude au clic, auto-parrainage).",
    "filters": {
      "allReasons": "Tous les motifs",
      "affiliateIdPlaceholder": "ID affilié..."
    },
    "columns": {
      "affiliate": "Affilié",
      "reason": "Motif",
      "flaggedAt": "Signalé le",
      "botHuman": "Bot / Humain (24h)",
      "conversion": "Conversions",
      "actions": "Actions"
    },
    "empty": "Aucun signalement ne correspond aux filtres.",
    "rowActions": {
      "whitelist": "Liste blanche",
      "suspend": "Suspendre"
    },
    "errors": {
      "suspend": "Échec de la suspension.",
      "whitelist": "Échec de la mise à jour de la liste blanche."
    },
    "toast": {
      "suspendSuccess": "Affilié suspendu.",
      "whitelistSuccess": "Liste blanche mise à jour."
    },
    "whitelistDialog": {
      "title": "Liste blanche IP pour @{{handle}}",
      "descPrefix": "Ignorer le signalement et marquer l'IP comme valide. Cette action ajoute l'IP à",
      "descSuffix": "de l'affilié (D-GA-10)."
    }
  },
  "shortlinks": {
    "heading": "Short Links",
    "subtitle": "Gérer les short-links de marque des affiliés + analytique.",
    "filters": {
      "searchPlaceholder": "Rechercher par slug ou URL cible...",
      "affiliateIdPlaceholder": "ID affilié...",
      "allBanned": "Tous",
      "banned": "Bannis",
      "active": "Actifs"
    },
    "columns": {
      "slug": "Slug",
      "affiliate": "Affilié",
      "targetUrl": "URL cible",
      "clicks": "Clics",
      "conversions": "Conversions",
      "status": "Statut",
      "actions": "Actions"
    },
    "empty": "Aucun ShortLink ne correspond aux filtres.",
    "bannedAt": "Banni : {{date}}",
    "statusActive": "Actif",
    "rowActions": {
      "ban": "Bannir"
    },
    "errors": {
      "ban": "Échec du bannissement."
    },
    "toast": {
      "banSuccess": "ShortLink banni."
    },
    "banDialog": {
      "title": "Bannir le ShortLink /r/{{slug}}",
      "desc": "Cette action supprime logiquement le ShortLink. Les résolutions suivantes renvoient 410 Gone. Indiquez le motif pour le journal d'audit.",
      "reasonLabel": "Motif"
    }
  }
}
